module.exports = __webpack_public_path__ + "static/media/np_3.c8872e8d.jpg";